import { Formik } from "formik";
import moment from "moment";
import { DOMINIOS_VALIDOS } from "../../utils/Constants";
import { mensajeSimple } from "../../components/ui/sweetAlerts";

const validateLaborales = (values, errors) => {
    const { fechaIngreso, cargo, planHorario, tipoContrato } = values.datosLaborales;

    if (!fechaIngreso) { errors.datosLaborales.fechaIngreso = "Requerido"; }

    if (moment(fechaIngreso).format('MM') < moment().format('MM')) { errors.datosLaborales.fechaIngreso = "No se puede seleccionar un mes anterior"; }

    if (moment(fechaIngreso).format('MM') >= moment().format('MM') && moment(fechaIngreso) < moment().subtract(5, 'days')) { errors.datosLaborales.fechaIngreso = "No se puede ingresar una fecha con más de 5 días de retraso"; }

    if (!cargo) { errors.datosLaborales.cargo = "Requerido"; }

    if (!planHorario) { errors.datosLaborales.planHorario = "Requerido"; }

    if (!tipoContrato) { errors.datosLaborales.tipoContrato = "Requerido"; } else if (tipoContrato && !fechaIngreso) {
        errors.datosLaborales.tipoContrato = "Es necesario la fecha de ingreso";
    }
}

const validatePersonales = (values, errors) => {
    const {
        nombres,
        apellidoPaterno,
        apellidoMaterno,
        fechaNacimiento,
        sexo,
        nacionalidad,
        email,
        telefonoCelular,
    } = values.datosPersonales;

    const { fechaIngreso } = values.datosLaborales;

    if (!nombres) { errors.datosPersonales.nombres = "Requerido"; }

    if (!apellidoPaterno) { errors.datosPersonales.apellidoPaterno = "Requerido"; }

    if (!apellidoMaterno) { errors.datosPersonales.apellidoMaterno = "Requerido"; }

    if (!fechaNacimiento) { errors.datosPersonales.fechaNacimiento = "Requerido"; }

    if (moment(fechaIngreso).diff(moment(fechaNacimiento), "years") < 18) { errors.datosPersonales.fechaNacimiento = "La persona debe ser mayor de 18 años."; }

    if (!sexo) { errors.datosPersonales.sexo = "Requerido"; }

    if (!nacionalidad) { errors.datosPersonales.nacionalidad = "Requerido"; }

    if (!email) { errors.datosPersonales.email = "Requerido"; } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
        errors.datosPersonales.email = "Direccion de correo invalida.";
    }
    else if (DOMINIOS_VALIDOS.includes(email.split("@")[1])) {
        errors.datosPersonales.email = "El dominio del correo es inválido";
    }

    if (telefonoCelular.length < 8 || telefonoCelular.length > 8) {
        errors.datosPersonales.telefonoCelular = "debe ingresar 8 digitos.";
    }
}

const validatePersonaExtranjera = (values, errors) => {
    const { tipoVisa, visaTemporariaDesde, visaTemporariaHasta } = values.datosPersonaExtranjera;
    const { nacionalidad } = values.datosPersonales;

    if (nacionalidad !== "1" && !tipoVisa) { errors.datosPersonaExtranjera.tipoVisa = "Requerido"; }

    if (nacionalidad !== "1" && tipoVisa === "2" && !visaTemporariaDesde) { errors.datosPersonaExtranjera.visaTemporariaDesde = "Requerido"; }

    if (nacionalidad !== "1" && tipoVisa === "2" && !visaTemporariaHasta) { errors.datosPersonaExtranjera.visaTemporariaHasta = "Requerido"; }
}

const validateDireccion = (values, errors) => {
    const { calle, numeroCasa, numeroDepartamento, region, comuna, tipoDireccion } = values.datosDireccion;

    if (!tipoDireccion) { errors.datosDireccion.tipoDireccion = "Requerido"; }

    if (!calle) { errors.datosDireccion.calle = "Requerido"; }

    if (!numeroCasa) { errors.datosDireccion.numeroCasa = "Requerido"; }
    else if (numeroCasa < 0) { errors.datosDireccion.numeroCasa = "Ingrese un numero válido"; }
    else if (String(numeroCasa).trim().length > 6) { errors.datosDireccion.numeroCasa = "Máximo 6 caracteres"; }

    if (numeroDepartamento && numeroDepartamento < 0) { errors.datosDireccion.numeroDepartamento = "Ingrese un numero válido"; }

    if (!region) { errors.datosDireccion.region = "Requerido"; }

    if (!comuna) { errors.datosDireccion.comuna = "Requerido"; }
}

const validatePrevision = (values, errors) => {
    const { jubilado, previsionSalud, previsionSocial, planPactado } = values.datosPrevision;
    const regexp = /^\d+(\.\d{1,4})?$/;

    if (!jubilado) { errors.datosPrevision.jubilado = "Requerido"; }

    if (!previsionSalud) { errors.datosPrevision.previsionSalud = "Requerido"; }

    if (!previsionSocial) { errors.datosPrevision.previsionSocial = "Requerido"; }

    if (previsionSalud !== "1" && !planPactado) { errors.datosPrevision.planPactado = "Requerido"; }

    if (previsionSalud !== "1" && Number.isNaN(planPactado)) { errors.datosPrevision.planPactado = "Ingrese corretamente el valor de la UF"; }
    else if (planPactado && !regexp.test(planPactado)) { errors.datosPrevision.planPactado = "Deben tener entre 1 a 4 decimales"; }
}

const validateBancarios = (values, errors) => {
    const { formaDePago, tipoCuenta, banco, numeroCuenta } = values.datosBancarios;

    if (!formaDePago) { errors.datosBancarios.formaDePago = "Requerido"; }

    if (formaDePago === "2" && !banco) { errors.datosBancarios.banco = "Requerido"; }

    if (formaDePago === "2" && !tipoCuenta) { errors.datosBancarios.tipoCuenta = "Requerido"; }

    if (formaDePago === "2" && !numeroCuenta) { errors.datosBancarios.numeroCuenta = "Requerido"; }
}

export const validate = (values) => {
    let errors = {
        datosLaborales: {},
        datosPersonales: {},
        datosPersonaExtranjera: {},
        datosBancarios: {},
        datosDireccion: {},
        datosPrevision: {},
        datosDocumentos: {},
    };

    validateLaborales(values, errors);
    validatePersonales(values, errors);
    validatePersonaExtranjera(values, errors);
    validateDireccion(values, errors);
    validatePrevision(values, errors);
    validateBancarios(values, errors);

    const noHayErrores = Object.values(errors).every(el => Object.values(el).length === 0);
    errors = noHayErrores ? Formik.setErrors({}) : errors

    return errors;
};

export const fileSize = (size) => {
    if (size <= 10485760) { return true; } //20971520 = 20Mb ------ 124288 = prueba
    else {
        mensajeSimple('info', 'Archivo muy pesado', 2500);
        return false;
    }
}
